import script from "./OrderProductPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderProductPreview.vue?vue&type=script&setup=true&lang=js"

import "./OrderProductPreview.vue?vue&type=style&index=0&id=160f1ad0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-160f1ad0"]])

export default __exports__